import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PetitionerService } from '../../../services/petitioner.service';
import { Petition } from '../../../data/models/petition.model';
import * as Roles from '../../../data/constants/roles';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-manage-petition',
  templateUrl: './manage-petition.component.html',
  styleUrls: ['./manage-petition.component.scss']
})
export class ManagePetitionComponent implements OnInit {
  isCreateAndEdit: boolean = false;
  isViewPetition: boolean = false;
  isStatusBeneficiary: boolean = false;
  petitionCount: any;
  dataSource: MatTableDataSource<Petition>;
  displayedColumns: string[] = ['name', 'petitionType', 'company', 'dateFiled', 'action'];


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private apiService: PetitionerService,
    private toastr: ToastrService,
    private router: Router, private authenticationService: AuthenticationService,
    private route: ActivatedRoute) {
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe((data) => {
      data = data||{permissions:[]};
      data['permissions'].forEach(el => {
        if(el === 'EDIT_PETITION'){
          this.isCreateAndEdit = true;
        }
      });
      data['permissions'].forEach(el => {
        if(el === 'VIEW_PETITION') {
          this.isViewPetition = true;
        }
      });
    });
    // if(sessionStorage.getItem('userTypeRole')=='Beneficiary'){
    //   // let companyId = (sessionStorage.getItem('companyId') && parseInt(sessionStorage.getItem('companyId')))? parseInt(sessionStorage.getItem('companyId')): 0;
    //   this.apiService.getPetitionsByBeneficiaryId(parseInt(sessionStorage.getItem('beneficiaryId')),
    //   parseInt(sessionStorage.getItem('companyId'))).subscribe((response: any) => {
    //     response.petitionsList.forEach(element => {
    //       element.createdDate = moment(element.createdDate).format('YYYY-MM-DD')
    //     });
    //     // console.log("orange", response);
    //     this.loadBeneficairy(response);
    //   });
    // }else{
      if (sessionStorage.getItem('companyId') !== 'null') {
        this.apiService.getPetitionsByCompanyId(parseInt(sessionStorage.getItem('companyId')), {
          'searchByBeneficiaryFirstname': ''
        }).subscribe((response: any) => {
          response.petition_list.forEach(element => {
            element.createdDate = moment(element.createdDate).format('YYYY-MM-DD')
          });
          this.loadPetitions(response);
        });
      }
    // }

  }

  loadPetitions(response) {
    this.petitionCount = response['count_petitions'];
    this.dataSource = new MatTableDataSource(response['petition_list']);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  handlePetition(petition: Petition) {
    sessionStorage.setItem('petitionId', petition.petitionId.toString());
    this.router.navigate(['../petition'], { relativeTo: this.route });
  }

  handleDblClick(petition: Petition) {
    this.handlePetition(petition);
  }

  createTask(){
    this.router.navigate(['petitioner-landing/dashboard/task/task-details', 0]);
  }

}
